import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getChatLogsApiClient } from "@shared/apis/sidekick/api-factories";
import { GetChatLogsThreadResponse } from "@shared/apis/sidekick/generated";

type Params = {
  userId: string;
  threadId: string | null;
};
const buildAdminGetUserThreadLogsQueryKey = (params: Params) => {
  return ["admin-user-thread-logs", { ...params }];
};

type Props = {
  onSuccess?: (data: GetChatLogsThreadResponse) => void;
  onError?: () => void;
} & Params;

export const useAdminGetUserThreadLogs = (props: Props) => {
  const { userId, threadId, onSuccess, onError } = props;
  const chatApi = getChatLogsApiClient();
  const query = useQuery({
    queryKey: buildAdminGetUserThreadLogsQueryKey({ userId, threadId }),
    queryFn: async () => {
      try {
        const data = await chatApi.chatLogsControllerAllLogs({
          userId,
          threadId: threadId ?? "",
        });
        onSuccess?.(data);
        return data;
      } catch (error) {
        console.error(
          `Failed to get user thread logs with id ${threadId}.`,
          error
        );
        onError?.();
        throw error;
      }
    },
    enabled: !!threadId,
    retry: false,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return extractQueryState(query);
};
